var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "failed-active_svg__a",
    x1: "100%",
    x2: "0%",
    y1: "10.042%",
    y2: "89.958%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF7F3F"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5.333 1.667)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#failed-active_svg__a)",
    stroke: "#202E4A",
    strokeWidth: 2,
    d: "M21.106 16.496L12.144.865a1.69 1.69 0 00-1.035-.803 1.68 1.68 0 00-1.296.166C9.55.38 9.333.6 9.182.864L.225 16.498a1.727 1.727 0 00.635 2.346c.26.148.55.227.846.227h17.92a1.715 1.715 0 001.708-1.72c0-.3-.079-.596-.228-.855h0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 2.083,
    d: "M10.667 6v5.333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.667,
    cy: 14.667,
    r: 1.333,
    fill: "#202E4A"
  }))));
}
export default SvgFailedActive;